export const mutations = {
  changeProjectType(state, type) {
    state.projectType = type;
  },
};
